import {
    DocumentRequestVisitReservationRequest,
    DocumentRequestVisitReservationRequestList
} from '@/common/ts/DocumentRequestVisitReservationRequestList';
import $ from 'jquery';

import Vue from 'vue';
import VueCompositionApi from '@vue/composition-api';
import VueScrollTo from 'vue-scrollto'
Vue.use(VueCompositionApi);

//スムーススクロール用
Vue.use(VueScrollTo)

Vue.config.errorHandler = e => {
    console.error(e);
};

window.onload = () => {
    const nav = $('.js-nav');
    const offset = nav.offset();
    const navHeight = nav.outerHeight() || 0;
    var scrollFrag = false;
    document.addEventListener('scroll', function() {
        //初回スクロール時のみ中間ナビゲーションのスタイル制御を発火させる
        if(scrollFrag !== true) {
            scrollFrag = true;
            // 中間ナビゲーションのスタイル制御
            // handleMiddleNavStyle(navHeight);
        }
    });
    $(window).on('scroll', function () {
        if ($(this).scrollTop() || 0 > 200) {
            $(nav).addClass('is-fixed');
            $(nav).removeClass('is-fixedOut');
        } else {
            $(nav).removeClass('is-fixed');
            $(nav).addClass('is-fixedOut');
        }
    });
};


const addClickEvent = async function (targetElm: JQuery<HTMLElement>, facilityRequests: DocumentRequestVisitReservationRequestList) {
    targetElm.on('click', async function () {
        await facilityRequests.init();
        const facilityId = Number(document.documentElement.dataset.facilityId);
        const facilityName = document.documentElement.dataset.facilityName || '';
        const type: string = $(this).data('reserveType');
        const fq = facilityRequests.value.find(f => f.facilityId === facilityId);

        if (!fq) {
            // TODO error modalの設定は必要かもしれない
            await facilityRequests.add({
                facilityId: facilityId,
                name: facilityName,
                isRequestVisit: type === 'visit-reservation',
                isRequestDocument: type === 'document',
                lastUpdatedAt: Math.floor(new Date().getTime() / 1000)
            });
        } else {
            const value: DocumentRequestVisitReservationRequest = {
                facilityId: fq?.facilityId,
                name: fq?.name,
                isRequestVisit: type === 'visit-reservation' ? true : fq?.isRequestVisit,
                isRequestDocument: type === 'document' ? true : fq?.isRequestDocument,
                lastUpdatedAt: Math.floor(new Date().getTime() / 1000)
            };
            await facilityRequests.update(value);
        }

        location.href = '/step/snr_step/step_init.html';
    });
};

/**
 * 離脱防止モーダル
 */
const addLeaveModalEvent = () => {

    let currentHeight = 0;

    // 離脱防止モーダル表示
    const leaveModal = () => {
        const posi = $(window).scrollTop() || 0; //モーダル表示中、背景がスクロールされないよう固定
        currentHeight = posi;
        $('.leaveModal, .leave_overlay').show();
        $('html').addClass('scrollNone');
        $('html').css({ //モーダルを表示させた位置で背景を固定
            width: '100%',
            position: 'fixed',
            top: -1 * posi
        });
    };

    history.pushState(null, '', null);
    $(window).one('popstate', () => leaveModal());
    $('a').off('popstate');

    $('.modalArea__close,#lean_overlay, .leave_overlay').on('click', () => {
        $('.modalArea,#lean_overlay,.leave_overlay').hide();
        $('html').removeClass('scrollNone');
        $('html').attr('style', ''); //背景スクロール固定解除
        $('html, body').prop({scrollTop: currentHeight}); //位置を戻す
        return false;
    });
};


$(async () => {

    const facilityRequests = new DocumentRequestVisitReservationRequestList();
    const buttonReserve = $('.buttonReserve');
    const buttonRequest = $('.buttonRequest');
    const linkStep = $('.linkStep a');
    await addClickEvent(buttonReserve, facilityRequests);
    await addClickEvent(buttonRequest, facilityRequests);
    await addClickEvent(linkStep, facilityRequests);
    addLeaveModalEvent();

});


// 周辺の施設検索 セレクトボックスの変更
const doChangeRadius = (ev: Event) => {
    ev.preventDefault();
    const facilityId = document.documentElement.dataset.facilityId;
    const target = ev.currentTarget as HTMLSelectElement
    const radius = target.value;

    if ([3, 5, 8].includes(Number(radius))) {
        location.href = `/facility/${facilityId}/voice/?radius=${radius}#recommendArea`;
    } else {
        location.href = `/facility/${facilityId}/voice/`;
    }
}

window.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.js-change-radius').forEach(el => el.addEventListener('change', doChangeRadius));
});

